import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { merge } from 'lodash-es';

// import { reactPlugin } from '@datadog/browser-rum-react'; // Plugin disabled due to initialization conflict
import { DataDogRumConfig } from '../datasource/generated/models/DataDogRumConfig';

const defaultConfig: RumInitConfiguration = {
    applicationId: '9973522d-0c17-4b51-9151-97fab0b9be83',
    clientToken: 'pub3c24ff034c5b60b584cdfb9bb28fa989',
    site: 'us3.datadoghq.com',
    service: 'pli.watch',
    env: 'dev',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [window.location.origin],
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
};

export const initDatadog = (config?: DataDogRumConfig) => {
    // Merge defaults with provided config.
    // Explicitly map DataDogConfig fields to RumInitConfiguration if needed, 
    // but assuming keys match except for capitalization which JS handles if strictly typed, 
    // but DataDogConfig has camelCase keys in TS model generated.

    // NOTE: DataDogConfig from C# might come as CamelCase if configured in JSON options, 
    // or PascalCase. The generated model uses camelCase.

    let rumConfig = { ...defaultConfig };

    if (config) {
        rumConfig = merge(rumConfig, config);

        if (config.allowedTracingUrls) {
            rumConfig.allowedTracingUrls = [
                ...defaultConfig.allowedTracingUrls!,
                ...config.allowedTracingUrls
            ];
        }
    }

    // Ensure we don't re-init if already started? 
    // datadogRum.getInitConfiguration() might return something if initialized. 
    // But datadogRum throws if init called twice. passing a flag or checking might be safe.
    // For now we assume initDatadog is called once main config loads.

    // If init is called again, it warns/errors. We should wrap in try/catch or check.
    try {
        datadogRum.init(rumConfig);
    } catch (e) {
        console.warn('Datadog already initialized or error initializing', e);
    }
};

export { datadogRum };

